<app-nav_bar></app-nav_bar>
<router-outlet></router-outlet>
<app-footer></app-footer>